module.exports = __webpack_public_path__ + "media/images/plan-grid3-b0c140bb3ad2f79279379fdfb3c90c85.jpg";